import { render, staticRenderFns } from "./ExchangeContractTable.vue?vue&type=template&id=41d56790&"
import script from "./ExchangeContractTable.vue?vue&type=script&lang=js&"
export * from "./ExchangeContractTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports